export { default as CheckPermissions } from './CheckPermissions';
